import { Button, Form } from "reactstrap";
import { toast } from "react-toastify";
import useAxios from "../../../../Utils/useAxios";
import { InputField, SelectionField } from "../../../../CommonElements";
import updateUserRole from "../services/updateUserRole";
import createUserRole from "../services/createUserRole";
import { Controller, useForm } from "react-hook-form";
toast.configure();

const UserRoleForm = ({
  resetState,
  toggle,
  data,
  unitkerja,
  setUnitkerja,
}) => {
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const axiosInstance = useAxios();

  const createitem = (data) => {
    createUserRole(axiosInstance, data).then(() => {
      resetState();
      toggle();
    });
  };

  const updateItem = (data) => {
    updateUserRole(axiosInstance, data.pk, data).then(() => {
      resetState();
      toggle();
    });
  };

  return (
    <Form onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createitem)}>
      <Controller
        name="username"
        control={control}
        rules={{ required: "Harap masukkan username" }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Username"}
            defaultValue={data?.username}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="role"
        control={control}
        rules={{ required: "Harap masukkan role" }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Role"}
            defaultValue={data?.role}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="id_unit_kerja"
        control={control}
        rules={{ required: "Harap masukkan DPSJ" }}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"DPSJ"}
            placeholder={"-- select unit --"}
            defaultValue={data?.id_unit_kerja}
            options={unitkerja.map((row) => ({
              id: row.nama_unit_kerja,
              name: row.nama_unit_kerja,
            }))}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default UserRoleForm;
